module.exports = __webpack_public_path__ + "media/images/flags/GF-fb55ab96a1c3fbcd3bac85b210d0de4c.svg";